import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../shared/services';
// import { config } from '../../config';
import { Hosts } from '../models';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add auth header with jwt if user is logged in and request is to api url
        const currentUser = this.authenticationService.currentUserValue;
        const isLoggedIn = currentUser && currentUser.token;
        const isApiUrl = request.url.startsWith(Hosts.API_HOST);
        if (isLoggedIn && isApiUrl) {
            request = request.clone({
                setHeaders: {
                    // Authorization: `Bearer ${currentUser.token}`
                    Authorization: `${currentUser.token}`

                }
            });
        }

        return next.handle(request);
    }
}